import { render, staticRenderFns } from "./CreateListModal.vue?vue&type=template&id=4c2bf098&"
import script from "./CreateListModal.vue?vue&type=script&lang=js&"
export * from "./CreateListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports